import * as React from "react";

import { TBannerItem } from "../../../services/banner";
import { LinkTargetType, TModuleWithImgProps } from "../../../services/playground";

import BetterSwiper from "../../components/Swiper";
import ImageView from "../../../components/SmartImage";
import { transformAParam } from "utils/browser";

import { CarouselBannerWrap, DotsWrapper, Dot } from "./styles";
export interface CarouselBannerProps extends TModuleWithImgProps {
	elements: TBannerItem[];
	asideGap?: string;
}

const MCarouselBanner = (props: CarouselBannerProps) => {
	const {
		elements = [],
		positionId,
		placeholderBg,
		aTarget = LinkTargetType.Blank,
		isInApp,
	} = props;
	const [activeIndex, setActiveIndex] = React.useState(0);
	const bannerHeight = elements?.[0]?.height || "auto";
	return (
		<CarouselBannerWrap data-id={positionId} id={positionId}>
			<BetterSwiper
				isAutoSwipe={true}
				style={{
					width: "inherit",
					height: `${bannerHeight}`,
				}}
				{...(elements.length > 1 ? { onIndexChange: setActiveIndex } : {})}
			>
				{elements.map((item, i) => {
					const aProps = transformAParam({
						isInApp: !!isInApp,
						aTarget,
						link: item.link,
					});
					return (
						<a key={i} {...aProps}>
							<ImageView
								src={item.img}
								online={true}
								key={i}
								placeholder={placeholderBg}
								fallbackSrc={placeholderBg}
								style={{
									width: "100vw",
									height: "inherit",
								}}
							/>
						</a>
					);
				})}
			</BetterSwiper>
			<DotsWrapper>
				{elements.map((_, index) => (
					<Dot key={index} active={index === activeIndex} />
				))}
			</DotsWrapper>
		</CarouselBannerWrap>
	);
};

export default MCarouselBanner;
